import HttpClient from "../../../helpers/client";
import { IResponse } from "../../../interfaces/response.interface";

export const UpdateAnimalTagService = <T = any>(ID: string, newHid: string): Promise<IResponse<T>> => (new HttpClient()).patch<IResponse<T>>(`animal/tag/`, { ID, newHid })